import React from 'react'
import NewsletterAlertSuccess from './NewsletterAlertSuccess'
import NewsletterAlertError from './NewsletterAlertError'
import NewsletterAlertInfo from './NewsletterAlertInfo'

function NewsletterAlert({ setIsSubmitted, isSuccessfullyRegistered, hasEmailRegistered, hasServerError }) {
  if (isSuccessfullyRegistered) {
    return <NewsletterAlertSuccess />
  }

  if (hasServerError) {
    return <NewsletterAlertError onSubmit={() => setIsSubmitted(false)} />
  }

  if (hasEmailRegistered) {
    return <NewsletterAlertInfo onSubmit={() => setIsSubmitted(false)} />
  }

  return null
}

export default NewsletterAlert
